import { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiUploadCloud, FiLock, FiAlertTriangle } = FiIcons;
const platforms = ['Facebook', 'Instagram', 'TikTok', 'X', 'YouTube', 'WhatsApp', 'Other'];
const categories = ['Harassment', 'Hate speech', 'Threats', 'Impersonation', 'Body shaming', 'Other'];

function SubmitCase({ onSubmit }) {
  const [form, setForm] = useState({
    link: '',
    platform: '',
    description: '',
    category: '',
    anonymous: true
  });
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState('');

  const update = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value
    });
  };

  const submit = (event) => {
    event.preventDefault();

    if (!form.link.trim() || !form.platform || !form.description.trim() || !form.category) {
      setError('Please complete each required field.');
      return;
    }

    try {
      new URL(form.link);
    } catch {
      setError('Enter a valid link to the post or profile.');
      return;
    }

    onSubmit({ ...form, screenshotName: fileName, date: 'Just now' });
    setForm({ link: '', platform: '', description: '', category: '', anonymous: true });
    setFileName('');
    setError('');
  };

  return (
    <section className="form-page">
      <div className="page-intro">
        <span className="eyebrow"><SafeIcon icon={FiShield} /> Submit safely</span>
        <h1>Submit a case</h1>
        <p>Share a public link to a harmful post. Your case appears in the community feed after submission.</p>
      </div>
      <form className="case-form" onSubmit={submit} noValidate>
        <div className="form-grid">
          <label className="field field-full">
            Link to the post <span className="required">*</span>
            <input name="link" value={form.link} onChange={update} placeholder="https://…" type="url" required />
            <small>Share the public post link only. Do not include private information.</small>
          </label>
          <label className="field">
            Platform <span className="required">*</span>
            <select name="platform" value={form.platform} onChange={update} required>
              <option value="">Choose a platform</option>
              {platforms.map((item) => <option key={item}>{item}</option>)}
            </select>
          </label>
          <label className="field">
            Category <span className="required">*</span>
            <select name="category" value={form.category} onChange={update} required>
              <option value="">Choose a category</option>
              {categories.map((item) => <option key={item}>{item}</option>)}
            </select>
          </label>
          <label className="field field-full">
            Short description <span className="required">*</span>
            <textarea
              name="description"
              value={form.description}
              onChange={update}
              rows="4"
              maxLength="500"
              placeholder="Describe the harmful content without repeating slurs or sharing personal details."
              required
            />
            <small>{form.description.length}/500 characters</small>
          </label>
          <label className="upload-field field-full">
            <span className="upload-icon"><SafeIcon icon={FiUploadCloud} /></span>
            <span>
              <b>Optional screenshot</b>
              <small>Only share evidence you have permission to provide.</small>
            </span>
            <input
              type="file"
              accept="image/*"
              onChange={(event) => setFileName(event.target.files?.[0]?.name || '')}
            />
            <span className="upload-action">{fileName || 'Choose file'}</span>
          </label>
        </div>
        <label className="check-row">
          <input type="checkbox" name="anonymous" checked={form.anonymous} onChange={update} />
          <span><b>Submit anonymously</b><small>Your name will not be shown with this case.</small></span>
        </label>
        <div className="privacy-note">
          <SafeIcon icon={FiLock} />
          <span>We do not display a victim’s name unless they choose to share it. Avoid doxxing or identifying details.</span>
        </div>
        {error && <p className="form-error" role="alert">{error}</p>}
        <button className="button button-primary submit-button" type="submit">
          Submit case <span>→</span>
        </button>
        <div className="danger-note">
          <SafeIcon icon={FiAlertTriangle} />
          <span>If you are in danger or feeling unsafe, please contact local emergency services or a trusted person.</span>
        </div>
      </form>
    </section>
  );
}

export default SubmitCase;